import { guessCountryByPartialPhoneNumber } from "react-international-phone";

/** Digits only — drops "+", spaces, dashes, parentheses. */
const onlyDigits = (value?: string | null): string => (value ?? "").replace(/\D/g, "");

/**
 * Whether a phone value holds a real subscriber number beyond the country
 * dial code. With dial-code prefill ON, an untouched field carries just the
 * dial code (e.g. "+970") — that counts as empty here.
 * @param value - Phone value in E.164 format.
 * @returns true when there are digits past the country dial code.
 */
export const hasActualPhoneNumber = (value?: string | null): boolean => {
    const digits = onlyDigits(value);
    if (!digits) return false;
    const { country } = guessCountryByPartialPhoneNumber({ phone: value ?? "" });
    const dialCode = country?.dialCode ?? "";
    const rest = dialCode && digits.startsWith(dialCode) ? digits.slice(dialCode.length) : digits;
    return rest.length > 0;
};

/**
 * Normalises a phone value for storage: returns "" when the value is just a
 * dial code (prefill with no real number) or blank, otherwise the value
 * unchanged. Use so a bare "+970" is never persisted.
 * @param value - Phone value in E.164 format.
 * @returns The value, or "" when it carries no real number.
 */
export const stripDialCodeOnlyPhone = (value?: string | null): string =>
    hasActualPhoneNumber(value) ? (value ?? "") : "";
